export enum ResourceTypes {
  Generic = 'generic',
  Manual = 'manual',
}

export const enum TABLELIST_ACTIONS {
  INIT = '[TABLELIST] INIT',
  SET_CONFIG_TEMPLATE = '[TABLELIST] SET CONFIG TEMPLATE',
  CLEAR = '[TABLELIST] CLEAR',
  SET_IDS = '[TABLELIST] SET IDS',
  UPDATE_IDS = '[TABLELIST] UPDATE IDS',
  CLEAR_IDS = '[TABLELIST] Clear IDS',
  SET_PAGE = '[TABLELIST] SET PAGE',
  SET_PAGE_DATA = '[TABLELIST] SET PAGE DATA',
  CLEAR_DATA = '[TABLELIST] Clear PAGE DATA',
  SET_ENTITIES_AMOUNT = '[TABLELIST] SET ENTITIES AMOUNT',
  LOAD_ORDERS_FOR_TEST_ALL_ITEMS = '[TABLELIST] LOAD_ORDERS_FOR_TEST_ALL_ITEMS',
  SET_IDENTIFIER_DATA = '[TABLELIST] SET IDENTIFIER DATA',
  CLEAR_IDENTIFIER_DATA= '[TABLELIST] CLEAR IDENTIFIER DATA'
}
